import React from 'react'
import {browserHistory} from 'react-router'
import Datagrid from '../../Component/Table/index'
import User from 'EurestoClass/User'

class Search extends React.Component {

  constructor (props) {
    super(props)
  }

  static update (row) {
    browserHistory.push({
      pathname: '/stock/document/' + row.id
    })
  }

  render () {
    return (<Datagrid onClick={Search.update}
                      type="document"
                      search={'document_' + (this.props.name || '') + User.Entite.get().id}/>)
  }
}

export default Search





// WEBPACK FOOTER //
// ./app/App/Module/Stock/Page/Recherche/index.js